import { UserFacingError } from './errors'

export class ConnectAccessDeniedError extends UserFacingError {
  constructor() {
    super('You do not have access to messaging for this organization.')
    this.name = 'ConnectAccessDeniedError'
  }
}

export class AgeRestrictedError extends UserFacingError {
  constructor() {
    super("Messaging isn't available on your account.")
    this.name = 'AgeRestrictedError'
  }
}

export class EulaRequiredError extends UserFacingError {
  constructor() {
    super('Please accept the Connect messaging agreement to continue.')
    this.name = 'EulaRequiredError'
  }
}

export class ChannelNotFoundError extends UserFacingError {
  constructor() {
    super('This channel could not be found.')
    this.name = 'ChannelNotFoundError'
  }
}

export class DuplicateChannelNameError extends UserFacingError {
  constructor() {
    super('A channel with this name already exists.')
    this.name = 'DuplicateChannelNameError'
  }
}
